<template>
    <v-snackbar
        v-model="isNotifyActive"
        class="app-notify"
        left
        :timeout="notifyTimeout"
        color="mainNew"
    >
        <span class="white--text notify-text">{{ notifyText }}</span>
        <template v-slot:action="{ attrs }">
            <div class="notify-actions">
                <v-btn
                    v-if="notifyAction"
                    color="white"
                    text
                    v-bind="attrs"
                    class="notify-actions__btn"
                    @click="runNotifyAction"
                >
                    {{ notifyAction.label }}
                </v-btn>
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    class="notify-actions__btn"
                    @click="closeNotify"
                >
                    Закрыть
                </v-btn>
            </div>
        </template>
    </v-snackbar>
</template>

<script>
//Вызвать snackbar
//this.$store.dispatch('callNotify', 'notifyText')
//this.$store.dispatch('callNotify', { text: 'notifyText', action: { label: 'Войти', type: 'authLogin', email: 'user@mail.ru' } })
import { mapState } from 'vuex'
export default {
    name: 'Notify',
    data: () => ({
        timeout: 3000,
        companies: [],
        test: true,
    }),
    computed: {
        ...mapState(['notifyText', 'notifyAction']),
        isNotifyActive: {
            get() {
                return this.$store.state.isNotifyActive
            },
            set(value) {
                this.$store.commit('setIsNotifyActive', value)
            },
        },
        notifyTimeout() {
            return this.notifyAction ? -1 : this.timeout
        },
    },
    methods: {
        closeNotify() {
            this.$store.commit('setIsNotifyActive', false)
            this.$store.commit('setNotifyAction', null)
        },
        runNotifyAction() {
            const action = this.notifyAction
            if (action?.type === 'authLogin') {
                if (action.email) {
                    this.$store.commit('setAuthDialogPrefillEmail', action.email)
                }
                this.$store.commit('setAuthDialogStartSection', 'login')
                this.$store.commit('setIsAuthDialog', true)
            }
            this.closeNotify()
        },
    },
}
</script>
<style lang="sass" scoped>
.app-notify
    z-index: 2001 !important

.notify-text
    display: block
    max-width: 420px
    line-height: 1.45

.notify-actions
    display: flex
    flex-direction: column
    align-items: flex-end
    gap: 2px

    &__btn
        min-width: 72px
        margin: 0 !important
</style>
